import axios from 'axios';
import { fromEvent, interval, merge, Subject } from 'rxjs';
import { buffer, filter } from 'rxjs/operators';

import type { ClickStreamEvent } from '../analytics/uiMetrics';
import { buildUrl } from './helpers';
import { RecordAnalytics } from './resources';

const EVENT_BATCH_INTERVAL_MS = 3000;

const eventQueue = new Subject<ClickStreamEvent>();

const intervalTrigger = interval(EVENT_BATCH_INTERVAL_MS);
const isClient = typeof window === 'object';
const unloadTrigger = isClient ? fromEvent(document, 'pagehide') : [];

const eventObservable = eventQueue.pipe(
  buffer(merge(intervalTrigger, unloadTrigger)),
  filter(b => !!b.length)
);

const AnalyticsApi = {
  queue: (event: ClickStreamEvent) => {
    eventQueue.next(event);
  },
  recordNow: (analyticsEvents: ClickStreamEvent[] | ClickStreamEvent): Promise<unknown> => {
    const events = Array.isArray(analyticsEvents) ? analyticsEvents : [analyticsEvents];
    return axios.post(buildUrl(RecordAnalytics), events);
  }
};

eventObservable.subscribe({ next: AnalyticsApi.recordNow });

export default AnalyticsApi;
